<template>
  <div class="modal fade" id="add-account" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            id="add-account-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>

          <div class="bs-stepper  wizard-vertical-icons-example mt-2">
            <div class="bs-stepper-header">
              <div
                @click.prevent="goStep(1)"
                class="step"
                role="button"
                data-target="#account-details-vertical"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-user"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("accounts.personal_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("accounts.add_personal_info")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(2)"
                role="button"
                class="step"
                data-target="#personal-info-vertical"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-file-description"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("accounts.account_details")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("accounts.add_account_details")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(3)"
                role="button"
                class="step"
                data-target="#ip-info-vertical"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-file-description"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("accounts.ip_port_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("accounts.add_ip_port_info")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(4)"
                class="step"
                role="button"
                data-target="#social-links-vertical"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle"
                    ><i class="ti ti-adjustments-cog"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("accounts.other_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("accounts.add_other_info")
                    }}</span>
                  </span>
                </button>
              </div>
            </div>

            <div class="bs-stepper-content">
              <form onSubmit="return false">
                <!-- Personal Info -->
                <div id="account-details-vertical" class="content">
                  <div class="content-header mb-4">
                    <small>{{ $t("accounts.enter_personal_info") }}</small>
                  </div>
                  <div class="row g-6">
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.first_name")
                      }}</label>
                      <input
                        v-model="account.first_name"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.first_name')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.last_name")
                      }}</label>
                      <input
                        v-model="account.last_name"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.last_name')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.phone")
                      }}</label>
                      <input
                        v-model="account.phone"
                        type="text"
                        dir="auto"
                        class="form-control"
                        :placeholder="`${$t('accounts.phone')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.national_id")
                      }}</label>
                      <input
                        v-model="account.national_id"
                        type="text"
                        dir="auto"
                        class="form-control"
                        :placeholder="`${$t('accounts.national_id')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.phone_line")
                      }}</label>
                      <input
                        v-model="account.phone_line"
                        type="text"
                        dir="auto"
                        class="form-control"
                        :placeholder="`${$t('accounts.phone_line')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.email")
                      }}</label>
                      <input
                        v-model="account.email"
                        type="text"
                        dir="auto"
                        class="form-control"
                        :placeholder="`${$t('accounts.email')}`"
                      />
                    </div>
                    <div
                      v-if="!show_more"
                      @click="toggleShowMore(true)"
                      class="text-primary cursor-pointer flex"
                    >
                      <p class="underline">{{ $t("accounts.show_more") }}</p>
                      <i class="ti ti-chevron-down"></i>
                    </div>
                    <div
                      v-if="show_more"
                      @click="toggleShowMore(false)"
                      class="text-primary cursor-pointer flex"
                    >
                      <p class="underline">{{ $t("accounts.show_less") }}</p>
                      <i class="ti ti-chevron-up"></i>
                    </div>
                    <div
                      class="col-sm-12"
                      v-if="this.$store.getters.settings.center == 1"
                    >
                      <label class="form-label" for="">رقم البوابة</label>
                      <input
                        v-model="account.address"
                        type="text"
                        class="form-control"
                        placeholder="رقم البوابة"
                      />
                    </div>
                  </div>
                  <div class="row g-6 mt-0" v-if="show_more">
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.father_name")
                      }}</label>
                      <input
                        v-model="account.father_name"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.father_name')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.mother_name")
                      }}</label>
                      <input
                        v-model="account.mother_name"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.mother_name')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.country")
                      }}</label>
                      <input
                        v-model="account.country"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.country')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.state")
                      }}</label>
                      <input
                        v-model="account.state"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.state')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.city")
                      }}</label>
                      <input
                        v-model="account.city"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.city')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.neighborhood")
                      }}</label>
                      <input
                        v-model="account.neighborhood"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.neighborhood')}`"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.street")
                      }}</label>
                      <input
                        v-model="account.street"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.street')}`"
                      />
                    </div>
                    <!-- <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.address_details")
                      }}</label>
                      <input
                        v-model="account.address"
                        type="text"
                        class="form-control"
                        :placeholder="`${$t('accounts.address_details')}`"
                      />
                    </div> -->
                    <div class="col-sm-12">
                      <label class="form-label" for="">{{
                        this.$store.getters.settings.center == 1
                          ? "رقم البوابة"
                          : $t("accounts.address")
                      }}</label>
                      <textarea
                        v-model="account.address"
                        class="form-control"
                        aria-label="Address"
                        :placeholder="`${$t('accounts.address_details')}`"
                      ></textarea>
                    </div>
                  </div>
                  <div class="row g-6 mt-0">
                    <div class="col-12 d-flex justify-content-between">
                      <button class="btn btn-label-secondary btn-prev" disabled>
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>
                      <button
                        @click.prevent="nextStep"
                        class="btn btn-primary btn-next"
                      >
                        <span
                          class="align-middle d-sm-inline-block d-none me-sm-2"
                          >{{ $t("control.next") }}</span
                        >
                        <i class="ti ti-arrow-right ti-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Account Details -->
                <div id="personal-info-vertical" class="content">
                  <div class="content-header mb-4">
                    <small>{{ $t("accounts.add_account_details") }}</small>
                  </div>
                  <div class="row g-6">
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("accounts.username")
                      }}</label>
                      <div class="input-group">
                        <input
                          v-model="account.username"
                          @input="validate"
                          type="text"
                          dir="auto"
                          class="form-control"
                          :placeholder="`${$t('accounts.username')}`"
                          :class="{ 'is-invalid': errors.username }"
                        />
                        <div v-if="errors.username" class="invalid-feedback">
                          {{ errors.username }}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label">{{
                        $t("accounts.password")
                      }}</label>
                      <div class="input-group input-group-merge">
                        <input
                          v-model="account.password"
                          :type="`${passwordVisible ? 'text' : 'password'}`"
                          @input="validate"
                          class="form-control"
                          autocomplete="new-password"
                          placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                          aria-describedby="basic-default-password"
                          :class="{ 'is-invalid': errors.password }"
                        />
                        <span
                          class="input-group-text cursor-pointer"
                          v-if="!passwordVisible"
                          @click="passwordVisible = !passwordVisible"
                          ><i class="ti ti-eye-off"></i
                        ></span>
                        <span
                          class="input-group-text cursor-pointer"
                          v-if="passwordVisible"
                          @click="passwordVisible = !passwordVisible"
                          ><i class="ti ti-eye"></i
                        ></span>
                        <div v-if="errors.password" class="invalid-feedback">
                          {{ errors.password }}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label">{{
                        $t("accounts.profile")
                      }}</label>
                      <select
                        class="form-select"
                        v-model="account.profile_id"
                        @change="
                          fix_date();
                          update_price();
                          fetchSerial();
                          validate();
                        "
                        :class="{ 'is-invalid': errors.profile_id }"
                      >
                        <option
                          v-for="(profile, index) in profiles"
                          :key="index"
                          :value="profile.id"
                          >{{ profile.name }}
                        </option>
                      </select>
                      <div v-if="errors.profile_id" class="invalid-feedback">
                        {{ errors.profile_id }}
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label">{{
                        $t("accounts.next_profile")
                      }}</label>
                      <select
                        class="form-select"
                        v-model="account.next_profile_id"
                        :disabled="
                          !hasPrivilege('accounts_edit_next_profile_accounts')
                        "
                        @change="validate"
                      >
                        <option
                          v-for="(profile, index) in profiles"
                          :key="index"
                          :value="profile.id"
                          >{{ profile.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label">{{
                        $t("accounts.serial_number")
                      }}</label>
                      <input
                        v-model="account.serial_number"
                        type="text"
                        disabled
                        class="form-control"
                        :placeholder="`${$t('accounts.serial_number')}`"
                        :class="{ 'is-invalid': errors.serial_number }"
                      />
                      <div v-if="errors.serial_number" class="invalid-feedback">
                        {{ errors.serial_number }}
                      </div>
                    </div>
                    <div v-if="user.type != 'reseller'" class="col-sm-6">
                      <label class="form-label">{{
                        $t("accounts.reseller")
                      }}</label>
                      <select
                        class="form-select"
                        v-model="account.reseller_id"
                        @change="validate"
                      >
                        <option class="font-light" :value="null">{{
                          $t("accounts.select_reseller")
                        }}</option>
                        <option
                          v-for="reseller in resellers"
                          v-bind:key="reseller.id"
                          :value="reseller.id"
                        >
                          {{ reseller.email }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12">
                      <div class="input-group input-group-merge">
                        <span class="input-group-text">{{
                          $t("accounts.notes")
                        }}</span>
                        <textarea
                          v-model="account.notes"
                          class="form-control"
                          aria-label="Notes"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                      <button
                        @click.prevent="previousStep"
                        class="btn btn-label-secondary btn-prev"
                      >
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>

                      <div class="d-flex gap-x-2">
                        <button
                          @click.prevent="store"
                          class="btn btn-success"
                          v-if="validated"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.save_and_close") }}</span
                          >
                          <i class="ti ti-check ti-xs"></i>
                        </button>
                        <button
                          @click.prevent="nextStep"
                          class="btn btn-primary btn-next"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.next") }}</span
                          >
                          <i class="ti ti-arrow-right ti-xs"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- IP info -->
                <div id="ip-info-vertical" class="content">
                  <div class="content-header mb-4">
                    <small>{{ $t("accounts.add_ip_port_info") }}</small>
                  </div>
                  <div class="row g-6">
                    <div class="col-sm-6">
                      <label class="form-label">
                        {{ $t("ips.pool.name") }}
                      </label>
                      <select
                        class="form-select"
                        v-model="account.ip_pool_id"
                        @change="
                          fetchPoolIps(true);
                          validate();
                        "
                      >
                        <option :value="null">N/A</option>
                        <option
                          v-for="pool in ip_pools"
                          v-bind:key="pool.id"
                          :value="pool.id"
                          dir="ltr"
                        >
                          {{ pool.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label">{{
                        $t("ips.pool.ip_address")
                      }}</label>
                      <select
                        class="form-select"
                        v-model="account.private_ip_id"
                        @change="validate"
                        :disabled="private_ips.length < 1"
                      >
                        <option :value="null">N/A</option>
                        <option
                          v-for="ip in private_ips"
                          v-bind:key="ip.id"
                          :value="ip.id"
                          dir="ltr"
                        >
                          {{ ip.ip_address }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("ips.public.public_address")
                      }}</label>
                      <select
                        class="form-select"
                        v-model="account.public_ip_port_id"
                        :disabled="account.private_ip_id == ''"
                        @change="validate"
                        :class="{ 'is-invalid': errors.public_ip_port }"
                      >
                        <option :value="null">N/A</option>
                        <option
                          v-for="ip in public_ips"
                          v-bind:key="ip.id"
                          :value="ip.id"
                          dir="ltr"
                        >
                          {{ ip.range }}
                        </option>
                      </select>
                      <div
                        v-if="errors.public_ip_port"
                        class="invalid-feedback"
                      >
                        {{ errors.public_ip_port }}
                      </div>
                    </div>

                    <div class="col-12 d-flex justify-content-between">
                      <button
                        @click.prevent="previousStep"
                        class="btn btn-label-secondary btn-prev"
                      >
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>

                      <div class="d-flex gap-x-2">
                        <button
                          @click.prevent="store"
                          class="btn btn-success"
                          v-if="validated"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.save_and_close") }}</span
                          >
                          <i class="ti ti-check ti-xs"></i>
                        </button>
                        <button
                          @click.prevent="nextStep"
                          class="btn btn-primary btn-next"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.next") }}</span
                          >
                          <i class="ti ti-arrow-right ti-xs"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Social Links -->
                <div id="social-links-vertical" class="content">
                  <div class="content-header mb-4">
                    <small>{{ $t("accounts.add_other_info") }}</small>
                  </div>
                  <div class="row g-6">
                    <div
                      class="col-sm-6"
                      v-if="
                        hasPrivilege('accounts_edit_expiration_accounts') &&
                          user.type != 'reseller'
                      "
                    >
                      <label class="form-label">{{
                        $t("accounts.expires_at")
                      }}</label>
                      <input
                        v-model="account.fixed_expiration"
                        type="datetime-local"
                        class="form-control"
                        placeholder="YYYY-MM-DD HH:MM"
                      />
                    </div>
                    <div
                      class="col-sm-6"
                      v-if="hasPrivilege('accounts_auto_renew_accounts')"
                    >
                      <label class="form-label">{{
                        $t("accounts.renew")
                      }}</label>

                      <select
                        v-model="account.auto_renew"
                        class="form-select"
                        data-style="btn-default"
                      >
                        <option value="0" selected>{{
                          $t("accounts.auto_renew_false")
                        }}</option>
                        <option value="1">{{
                          $t("accounts.auto_renew")
                        }}</option>
                      </select>
                    </div>
                    <div class="col-12" v-if="user.type != 'reseller'">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("accounts.has_ip")
                        }}</span>
                        <div class="input-group-text">
                          <input
                            v-model="has_static_ip"
                            class="form-check-input mt-0"
                            type="checkbox"
                            value=""
                            aria-label="Checkbox for following text input"
                            :class="{ 'is-invalid': errors.ip_address }"
                          />
                          <div
                            v-if="errors.ip_address"
                            class="invalid-feedback"
                          >
                            {{ errors.ip_address }}
                          </div>
                        </div>
                        <input
                          :disabled="!has_static_ip"
                          v-model="account.ip_address"
                          type="text"
                          class="form-control"
                          aria-label="Text input with checkbox"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("accounts.is_mac")
                        }}</span>
                        <div class="input-group-text">
                          <input
                            v-model="account.is_mac"
                            class="form-check-input mt-0"
                            type="checkbox"
                            value=""
                            aria-label="Checkbox for following text input"
                          />
                        </div>
                        <input
                          type="text"
                          :disabled="!account.is_mac"
                          v-model="account.mac_address"
                          class="form-control"
                          aria-label="Text input with checkbox"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6" v-if="user.type != 'reseller'">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("accounts.sessions")
                        }}</span>
                        <input
                          v-model="account.allowed_sessions"
                          type="number"
                          class="form-control"
                          aria-label="Text input with checkbox"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="input-group">
                        <span class="input-group-text">{{ price }}</span>
                        <span class="input-group-text">{{
                          settings.currency
                        }}</span>
                        <select class="form-select" v-model="account.paid">
                          <option value="1" selected>{{
                            $t("accounts.paid")
                          }}</option>
                          <option value="0">{{
                            $t("accounts.paid_false")
                          }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12" v-if="user.type == 'reseller'">
                      <div>
                        {{ $t("control.profile_cost", { price: price }) }}
                      </div>
                      <div>
                        {{
                          $t("control.benefit_cost", {
                            price: (price * user.benefit_rate) / 100,
                          })
                        }}
                      </div>
                      <div>
                        {{
                          $t("control.cost", {
                            cost:
                              price -
                              (price * user.benefit_rate) / 100 +
                              " " +
                              settings.currency,
                          })
                        }}
                      </div>
                      <div
                        :class="{
                          'text-danger':
                            user.money -
                              price +
                              (price * user.benefit_rate) / 100 <
                            0,
                        }"
                      >
                        {{
                          $t("control.money_left", {
                            original: user.money,
                            left:
                              user.money -
                              price +
                              (price * user.benefit_rate) / 100 +
                              " " +
                              settings.currency,
                          })
                        }}
                      </div>
                    </div>

                    <div class="col-12 d-flex justify-content-between">
                      <button
                        @click.prevent="previousStep"
                        class="btn btn-label-secondary btn-prev"
                      >
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>
                      <button
                        @click.prevent="store"
                        :disabled="!validated"
                        class="btn btn-success"
                      >
                        {{ $t("control.add") }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import ExpiredWindow from "./ExpiredWindow.vue";
import { hasPrivilege } from "../../global_constants.js";
export default {
  components: {
    ExpiredWindow,
  },
  name: "AddAccount",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      stepper: null,
      error: "",
      message: "",
      has_static_ip: false,
      has_expire_profile: false,
      has_fixed_expiration: false,
      account: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        username: "",
        password: "",
        address: "",
        notes: "",
        profile_id: "",
        expire_profile: "",
        ip_address: "",
        allowed_sessions: 1,
        auto_renew: 0,
        record_sessions: true,
        fixed_expiration: null,
        paid: 1,
        is_mac: 0,
        mac_address: "",
        next_profile_id: "",
        serial_number: null,
        wait_days: null,
        private_ip_id: null,
        public_ip_port_id: null,
        ip_pool_id: null,
        reseller_id: null,
      },
      ip_pools: [],
      private_ips: [],
      public_ips: [],
      show_more: false,
      startTime: {
        hours: 0,
        minutes: 0,
      },
      loading: false,
      profiles: null,
      isError: false,
      resellers: null,
      error_message: "",
      errors: {
        username: null,
        password: null,
        profile_id: null,
        ip_address: null,
        serial_number: null,
      },
      passwordVisible: false,
      validated: false,
      date_format: (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();

        return `${day}-${month}-${year} ${hour}:${minute}`;
      },
      price: 0,
    };
  },
  async created() {
    this.loading = true;
    await this.fetchProfiles();
    await this.fetchIpPools();
    await this.fetchPublicIpPorts();
    if (this.$route.params.id) {
      await this.fetchAccount(this.$route.params.id);
      this.validated = true;
      if (this.account.serial_number == null) await this.fetchSerial();
    }
    if (localStorage.getItem("show_more_accounts") != null) {
      this.show_more = localStorage.getItem("show_more_accounts") == "true";
    }
    this.fetchResellers();
    this.loading = false;
  },
  mounted() {
    this.stepper = new Stepper(document.querySelector(".bs-stepper"), {
      linear: true,
      animation: false,
      selectors: {
        steps: ".step",
        trigger: ".step-trigger",
        stepper: ".bs-stepper",
      },
    });
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async store() {
      this.loading = true;
      this.account.fixed_expiration = moment(
        this.account.fixed_expiration
      ).format("yyyy-MM-DD HH:mm");
      if (this.account.id) {
        if (this.account.profile_id == null) {
          this.validate();
          return;
        }
        const response = await axios.put(
          `/accounts/${this.account.id}`,
          this.account
        );
        if (response.status == 200) {
          if (this.user.type == "reseller") {
            this.user.money =
              this.user.money -
              this.price +
              (this.price * this.user.benefit_rate) / 100;
          }
          document.getElementById("add-account-close").click();
          this.$notify({
            text: "Account Updated Successfully",
            type: "success",
          });
          this.$emit("updated");
        }
      } else {
        const response = await axios.post("/accounts", this.account);
        if (response.status == 200) {
          if (this.user.type == "reseller") {
            this.user.money =
              this.user.money -
              this.price +
              (this.price * this.user.benefit_rate) / 100;
          }
          document.getElementById("add-account-close").click();
          this.$notify({
            text: "Account Added Successfully",
            type: "success",
          });
          this.$emit("updated");
        } else {
          if (response.data.error == "username_already_exists") {
            this.errors.username = this.$t("errors.accounts.username_taken");
            this.validated = false;
          }
          if (response.data.error == "username_already_exists_card") {
            this.errors.username = this.$t("errors.accounts.username_taken");
            this.validated = false;
          }
          if (response.data.error == "serial_number_already_exists") {
            this.errors.serial_number = this.$t(
              "errors.accounts.serial_number_taken"
            );
            this.validated = false;
          }
        }
        this.loading = false;
      }
    },
    async fetchProfiles() {
      const response = await axios.get(
        "/profiles?itr=1&type=subscribtion&rows=1000000"
      );
      if (response.status == 200) this.profiles = response.data.data;
    },
    async fetchResellers() {
      const response = await axios.get(
        "admins?filter=1&type=resellers&rows=10000&itr=true"
      );
      if (response.status == 200) this.resellers = response.data.data;
    },
    async fetchSerial() {
      let profile = this.profiles.filter((profile) => {
        return profile.id == this.account.profile_id;
      });
      profile = profile[0];
      profile = ("000" + profile.id).substr(-3);
      var user = ("000" + this.user.id).substr(-3);
      const response = await axios.get(
        `/accounts/serial?starter=${user}${profile}`
      );
      if (response.status == 200)
        this.account.serial_number = response.data.data;
    },
    async fetchIpPools() {
      const response = await axios.get("/ip/pool?itr=1&rows=1000000");
      if (response.status == 200) this.ip_pools = response.data.data;
    },
    async fetchPoolIps(one_time = false) {
      if (one_time) this.loading = true;
      const response = await axios.get(
        `/ip/private?itr=1&state=unused&ip_pool=${this.account.ip_pool_id}&rows=1000000&account_id=${this.account.id}`
      );
      if (response.status == 200) this.private_ips = response.data.data;
      if (one_time) this.loading = false;
    },
    async fetchPublicIpPorts() {
      const response = await axios.get(
        `/ip/port?itr=1&state=unused&rows=1000000&account_id=${this.account.id}`
      );
      if (response.status == 200) this.public_ips = response.data.data;
    },
    update_price() {
      let profile = this.profiles.filter((profile) => {
        return profile.id == this.account.profile_id;
      });
      profile = profile[0];
      this.price = profile.price;
    },
    fix_date() {
      if (this.account.id) return;
      let profile = this.profiles.filter((profile) => {
        return profile.id == this.account.profile_id;
      });
      profile = profile[0];
      this.account.fixed_expiration = moment().add(
        profile.expiration_value,
        profile.expiration_unit
      );
      if (
        profile.expiration_unit != "hours" &&
        this.settings.default_expiration_hour != -1
      ) {
        this.account.fixed_expiration.hours(
          this.settings.default_expiration_hour ?? 12
        );
        this.account.fixed_expiration.minutes(0);
      }
      this.account.fixed_expiration = this.account.fixed_expiration.format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    async fetchAccount(id) {
      const response = await axios.get(`/accounts/${id}`);
      if (response.status == 200) {
        this.account = response.data.data;
        this.account.profile_id = this.account.profile.id;
        if (this.account.expire_profile) {
          // this.account.expire_profile_id = this.account.expire_profile.id;
          this.has_expire_profile = true;
        }
        if (this.account.ip_address) {
          this.has_static_ip = true;
        }
        if (this.account.expires_at) {
          this.account.fixed_expiration = moment(this.account.expires_at);
        }
      }
    },
    changeProfile(profile_id) {
      this.account.profile_id = profile_id;
    },
    nextStep() {
      this.stepper.next();
    },
    previousStep() {
      this.stepper.previous();
    },
    goStep(num) {
      this.stepper.to(num);
    },
    toggleShowMore(value) {
      this.show_more = value;
      localStorage.setItem("show_more_accounts", value);
    },
    validate() {
      this.validated = true;
      this.errors.username = null;
      this.errors.mac_address = null;
      this.errors.public_ip_port = null;
      if (!this.account.username) {
        this.errors.username = this.$t("errors.accounts.username_empty");
        this.validated = false;
      }
      if (this.account.username.length < 2) {
        this.validated = false;
        this.errors.username = this.$t("errors.accounts.username_2");
      }
      if (this.account.username.includes("*")) {
        this.validated = false;
        this.errors.username = this.$t("errors.accounts.username_symbol");
      }
      if (
        this.account.username.indexOf("@") !=
        this.account.username.lastIndexOf("@")
      ) {
        this.validated = false;
        this.errors.username = "cannot contain more than @ symbol";
      }
      this.errors.password = null;
      if (!this.account.password) {
        this.validated = false;
        this.errors.password = this.$t("errors.accounts.password_empty");
      }
      if (this.account.password.length < 2) {
        this.validated = false;
        this.errors.password = this.$t("errors.accounts.password_2");
      }
      this.errors.profile_id = null;
      if (!this.account.profile_id) {
        this.validated = false;
        this.errors.profile_id = this.$t("errors.accounts.select_profile");
      }
      this.errors.ip_address = null;
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          this.account.ip_address
        ) == false &&
        this.has_static_ip
      ) {
        this.validated = false;
        this.errors.ip_address = this.$t("errors.accounts.invalid_ip");
      }
      if (
        this.user.money -
          this.price +
          (this.price * this.user.benefit_rate) / 100 <
          0 &&
        this.user.type == "reseller"
      ) {
        this.validated = false;
      }
      if (
        /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$/.test(
          this.account.mac_address
        ) == false &&
        this.account.is_mac == 1 &&
        this.account.mac_address != ""
      ) {
        this.errors.mac_address = this.$t(
          "errors.accounts.invalid_mac_address"
        );
        this.validated = false;
      }
      if (this.account.is_mac) {
        this.account.allowed_sessions = 1;
      }
      if (
        this.account.private_ip_id &&
        this.account.ip_pool_id &&
        !this.account.public_ip_port_id
      ) {
        this.errors.public_ip_port = this.$t("errors.ips.ip_required");
        this.validated = false;
      }
    },
  },
};
</script>
